var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gj-no-data"},[_c('img',{staticClass:"no-patient-pic",attrs:{"src":require("@/assets/images/no-content.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }